import { createFileRoute, redirect } from '@tanstack/react-router'
import { SettingsPage } from '@/pages/Settings/SettingsPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/settings')) {
      throw redirect({ to: '/' })
    }
  },
})
